import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { AuthService } from './../../shared/models/auth.service';
import { CompanyModel } from "./../../company/models/company.model";
import { DataListModel, ApplicationRouteURL } from '../../shared/config';
import { Observable } from 'rxjs/Observable';
import { TermsAndConditionsService } from '../models/terms-conditions.service';
import { TermsConditionActivityLog } from '../../termsconditionpopup/models/terms-condition-activity-log.model';

@Component({
  selector: "wego-tc-activitylog-driver",
  template: require('../views/tc-activity-log-driver.component.html'),
  providers: [
    TermsAndConditionsService
  ]
})

export class TCActivityLogDriverComponent implements OnInit {
  DataListModel: DataListModel = new DataListModel();
  TandCActivityLog: TermsConditionActivityLog[];
  isLoading: boolean;
  apiErrorMsg: string;
  LblIcon: string = "fa fa-plus-square";


  @ViewChild("termsConditionModel") public termsConditionModel: any;

  constructor(
    private TermsAndConditionService: TermsAndConditionsService,
    private authService: AuthService
  ) { }

  ngOnInit() {
    this.DataListModel.searchField = ["termsAndConditionName", "actionName", "companyName", "organizationName", "svgName", "version"];
    this.GetTAndCActivityList();
  }

  private GetTAndCActivityList() {
    this.isLoading = true;
    this.TermsAndConditionService.GetTermsAndConditionActivityListDriver(this.DataListModel)
      .subscribe(
        res => {
          this.TandCActivityLog = res.data;
          this.DataListModel.totalItems = res.totalRecords;
          this.DataListModel.infoMessage = res.error;
          this.isLoading = false;
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        });
  }

  public OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetTAndCActivityList();
  }

  public OnSearch(event: any) {
    this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
    this.GetTAndCActivityList();
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetTAndCActivityList();
  };

  public OnPagingChange(event: any) {
    console.log(this.DataListModel);
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetTAndCActivityList();
  }

  public OnExport(event: any) {
    this.isLoading = true;
    this.TermsAndConditionService
      .ExportTermsAndConditionActivityListDriver(this.DataListModel)
      .subscribe(
        (res: any) => {
          if (res && res._body) {
            let fileName = "TermsAndConditionActivityLog" + new Date().toISOString() + ".csv";
            this.authService.DownloadFile(fileName, res._body);
          }
          this.isLoading = false;
        },
        (error: any) => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }

  public ConfirmRevokePopup() {
    this.GetTAndCActivityList();
  }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/termsandcondition/components/tc-activity-log-driver.component.ts